import { HubConnection } from '@microsoft/signalr';

let accountHubConnection: HubConnection | null = null;

export const setAccountHubConnection = (connection: HubConnection | null) => {
  accountHubConnection = connection;
};

export const getAccountHubConnection = () => accountHubConnection;

export const stopAccountHubConnection = async () => {
  if (!accountHubConnection) {
    return;
  }

  const connection = accountHubConnection;
  accountHubConnection = null;

  try {
    await connection.stop();
  } catch (error) {
    console.error('Error stopping SignalR connection', error);
  }
};
